import * as Sentry from "@sentry/browser";

export const sentryInstance = Sentry;
